import * as SMLoggedInUserDirectCodesActions from './../actions/SMloggedInUserDirectCodes.actions';
import { AppState } from '../state/App.state';
import { SMLoggedInUserDirectBusinessCodessModel } from '../models/SMloggedInUserDetails.model';

const initialState = {
    SMDirectBussinessDetails: []
}

export function SMloggedInUserBusinessCodesDataReducer(state: SMLoggedInUserDirectBusinessCodessModel = initialState, action: SMLoggedInUserDirectCodesActions.Actions) {

    switch (action.type) {
        case SMLoggedInUserDirectCodesActions.UPDATE_SM_LOGGEDIN_USER_DIRECT_BUSINESS_CODES:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}
export const selectSMLoggedInUserDirectCodes = (state: AppState) => state.SMloggedinUserBusinessDirectCodes;